import { SelectChangeEvent } from '@mui/material'
import React, { useEffect, useRef, useState } from 'react'
import BorderHeading from '../../components/heading/BorderHeading'
import "./OrderConfiguration.css"
import { DashboardCheckbox, DashboardSelect, InputList } from '../../components/Input/Input';
import Input from "../../components/Input/Input"
import { configurationAttributeType, orderConfigurationValuesTypes } from '../../types';
import * as yup from 'yup';
import ConfigurationHeader from '../../components/heading/ConfigurationHeader';
import { convertValuesToConfig, createValidation, doFinalConfigSubmit, getNewConfiguration, overWriteConfig } from '../../services/uiConfigService';
import { defaultInputValues } from '../../components/constants/uiConfigConstants';
import { configObj } from '../../types/types';
import * as Sentry from "@sentry/react";
import QuestionHeading from '../../components/heading/QuestionHeading';
import { openPopup } from '../../stateManagement/actions/popupActions';
import { deepClone } from '@mui/x-data-grid/utils/utils';
import ConfigComparePopup from '../../components/popup/ConfigComparePopup';
import ImportConfig from '../../components/importConfig/ImportConfig';

// interface orderTrackingStageInputProps {
//     index: number,
//     stage: orderTrackingStageType,
//     OrderTrackingStagesValues: stageType[],
//     setOrderTrackingStagesValues: React.Dispatch<React.SetStateAction<stageType[]>>
// }

export const ShowDesc = (props: { config: configObj[] }) => {
    const { config } = props;
    return <ul>{config?.map((feature) => {
        return <li>{feature.featureName} : {feature.featureDesc}</li>
    })}</ul>
}

export const IndentWrapper = (props: { indent: number, children: React.ReactNode }) => {
    const { indent = 1, children } = props;
    return (
        <div style={{ marginLeft: `${indent ? indent * 1.5 : 1.5}rem`, marginTop: "1.5rem" }}>
            {children}
        </div>
    )
}

// const OrderTrackingStageInput = (props: orderTrackingStageInputProps) => {
//     const { setOrderTrackingStagesValues, OrderTrackingStagesValues, stage, index } = props;
//     const handleCheckChange = (e: React.ChangeEvent<HTMLInputElement>) => {
//         // e.preventDefault();
//         const arr = [...OrderTrackingStagesValues];
//         arr[index].value = !arr[index].value;
//         setOrderTrackingStagesValues(arr);
//     }
//     const handleValueChange = (e: React.ChangeEvent<HTMLInputElement>) => {
//         const arr = [...OrderTrackingStagesValues];
//         arr[index].label = e.target.value;
//         setOrderTrackingStagesValues(arr);
//     }
//     const handleColorInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
//         e.preventDefault();
//         const arr = [...OrderTrackingStagesValues];
//         arr[index].color = e.target.value;
//         setOrderTrackingStagesValues(arr);
//     }
//     return <><div className={"generic_form_container even_container"}>
//         <DashboardCheckbox onChange={handleCheckChange} checked={OrderTrackingStagesValues?.[index]?.value} label={OrderTrackingStagesValues[index]?.id} />
//     </div>
//         {OrderTrackingStagesValues[index]?.value && <>
//             <IndentWrapper indent={2}>
//                 <QuestionHeading>
//                     Write Label
//                 </QuestionHeading>
//                 <div className="answer_container">
//                     <Input name={stage.status} value={OrderTrackingStagesValues?.[index]?.label} onChange={handleValueChange} />
//                 </div>
//             </IndentWrapper>
//             <IndentWrapper indent={2}>
//                 <QuestionHeading>
//                     Write hex code
//                 </QuestionHeading>
//                 <div className="answer_container">
//                     <Input value={OrderTrackingStagesValues?.[index]?.color} inputProps={{ maxLength: 7 }} onChange={handleColorInputChange} />
//                 </div>
//             </IndentWrapper>
//         </>
//         }
//     </>
// }

const OrderConfiguration = () => {
    const [orderConfig, setOrderConfig] = useState<configurationAttributeType[]>([]);
    // const [orderTrackingStages, setOrderTrackingStages] = useState<orderTrackingStageType[]>([]);
    // const [orderTrackingStagesValues, setOrderTrackingStagesValues] = useState<stageType[]>([]);
    const [values, setValues] = useState<orderConfigurationValuesTypes>(deepClone(defaultInputValues))
    // const [filterValues, setFilterValues] = useState({
    //     filter1: '',
    //     filter2: '',
    //     filter3: '',
    // })
    // const [basketTitles,setBasketTitles]=useState<string[]>([]);
    const [orderValidationsSchema, setOrderValidationSchema] = useState({})
    // const [filterOptions] = useState([
    //     { value: 'brand', title: "Brand" },
    //     { value: 'category', title: "Category" },
    //     { value: 'subCategory', title: "Sub category" },
    //     { value: 'pieceSize', title: "Pack size" },
    //     { value: 'none', title: "None" }
    // ])
    const [showConfigPopup,setShowConfigPopup] = useState<boolean>(false);
    const curConfigRef = useRef<{[key:string]:any[]}>({});
    const newConfigRef = useRef<{[key:string]:any[]}>({});
    function performOrderValidations(): boolean {
        try {
            // const filter1 = filterValues?.filter1 !== 'none' ? true : false;
            // const filter2 = filterValues?.filter2 !== 'none' ? true : false;
            const isMinOrderTypeNone = values.minOrderType.value === 'value' || values.minOrderType.value === 'volume' ? false : true;
            const minOrderValue = values.minOrder.value;
            // const orderFeedbackToggle = values.orderFeedback.value;
            // const orderFeedbackText1 = values.orderInvoiceFeedback1.value;
            // const orderFeedbackText2 = values.orderInvoiceFeedback2.value;
            // const orderFeedbackText3 = values.orderInvoiceFeedback3.value;
            // const orderFeedbackText4 = values.orderInvoiceFeedback4.value;
            // const atleastOneOrderFeedback = orderFeedbackText1 || orderFeedbackText2 || orderFeedbackText3 || orderFeedbackText4;
            // if (filter1 && !filter2) {
            //     openPopup( 'Error','Please select atleast one more filter!');
            //     return false;
            // } else 
            if (!isMinOrderTypeNone && !minOrderValue) {
                openPopup( "Error",'Please fill minimum order value or volume field!');
                return false;
            // } else if (orderFeedbackToggle && atleastOneOrderFeedback === '') {
            //     openPopup('Please fill atleast one order invoice feedback!', "Error");
            //     return false;
            }
            return true
        } catch (err) {
            // Sentry.captureException(err);
            return false

        }
    }

    const getOrderConfiguration = async () => {
        try {
            const resp = await getNewConfiguration('order_configuration');
            const basketConfigResp = await getNewConfiguration('order_basket_configuration');
            // const tabFilterConfig = await getNewConfiguration('tab_filters');
            const order_config: configurationAttributeType[] = resp?.domainValues;
            curConfigRef.current.order_configuration = order_config  ?? [];
            // const orderTrackingResp: orderTrackingStageType[] = await getMetaData("supportedValues", "OrderDetails-status"); 
            // const filterResp = await getMetaData('filters', 'tab')
            // const result: { id: string, color: string, label: string, value: boolean }[] = [];
            const basketList:string[]=[];
            basketConfigResp && basketConfigResp["domainValues"][0]['value'].forEach((basket:{[key:string]:string})=>{
                basketList.push(basket['id']);
            })
            // setBasketTitles([...basketList]);
            // setOrderTrackingStages(orderTrackingResp)
            // orderTrackingResp.forEach((stage) => {
            //     const obj = {
            //         id: stage.status,
            //         color: '',
            //         label: '',
            //         labelColor:'',
            //         value: false,
            //     };
            //     result.push(obj)
            // })
            // setOrderTrackingStagesValues(result);
            setOrderConfig([...order_config])
            // if (filterResp) {
            //     setFilterValues({
            //         filter1: filterResp?.[0] ? filterResp?.[0]:'none',
            //         filter2: filterResp?.[1] ? filterResp?.[1]:'none',
            //         filter3: filterResp?.[2] ? filterResp?.[2]:'none',
            //     })
            // }
        } catch (err) {
            // Sentry.captureException(err);
        }
    }

    useEffect(() => {
        /**
         * This function fetches three types of configs: clientconfig , orderTrackingStages config , tab filters for order
         * getNewConfiguration - to get order_configuration
         * orderTrackingstages - This gets the status available in the backend .
         * getMetaData - This function gets the filters for  order at line 152
         */
        
        getOrderConfiguration();
    }, [])
    const handleCheckChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const keyName = e.target.name;
        setValues({
            ...values,
            [keyName]: {...values[keyName], value:e.target.checked, isValueUpdated:true} 
        })
    }
    const handleValueChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const keyName = e.target.name;
        setValues({
            ...values,
            [keyName]: {...values[keyName], value:e.target.value, isValueUpdated:true} 
        })
    }
    const handleDisclaimerChange = ( e: React.ChangeEvent<HTMLInputElement>, index: number) => {
        switch(e.target.name){
            case 'orderSummaryDisclaimer' :{
                const finalDisclaimer = [...values.orderSummaryDisclaimer.value];
                finalDisclaimer[index] = e.target.value;
                const keyName = e.target.name;
                setValues({
                    ...values,
                    [keyName]: {...values[keyName], value:[...finalDisclaimer], isValueUpdated:true} 
                })
                break;
            }
            case 'orderInvoiceDisclaimer' :{
                const finalDisclaimer = [...values.orderInvoiceDisclaimer.value];
                finalDisclaimer[index] = e.target.value;
                const keyName = e.target.name;
                setValues({
                    ...values,
                    [keyName]: {...values[keyName], value:[...finalDisclaimer], isValueUpdated:true} 
                })
                break;
            }
            case 'orderCancellationReasons' :{
               const finalDisclaimer = [...values.orderCancellationReasons.value];
                finalDisclaimer[index] = e.target.value;
                const keyName = e.target.name;
                setValues({
                    ...values,
                    [keyName]: {...values[keyName], value:[...finalDisclaimer], isValueUpdated:true} 
                })
                break;
            }
        }
        
    }

    const handleFeedbackChange = (e: React.ChangeEvent<HTMLInputElement>, index: number, type?: "issues" | "compliment" | undefined) => {
        let finalValueArr: string[];
        switch (type) {
            case "issues":
                finalValueArr = [...values.orderIssues.value];
                break;

            default:
                finalValueArr = [...values.orderCompliment.value]
                break;
        }
        finalValueArr[index] = e.target.value;
        const keyName = e.target.name;
        setValues({
            ...values,
            [keyName]: {...values[keyName], value:[...finalValueArr], isValueUpdated:true} 
        })
    }

    const handleSelectValueChange = (e: SelectChangeEvent<unknown>) => {
        const keyName = e.target.name;
        setValues({
            ...values,
            [keyName]: {...values[keyName], value:e.target.value, isValueUpdated:true} 
        });
    }
    // const handleFilterValueChange = (e: SelectChangeEvent<any>) => {
    //     if (e.target.name === "filter1" && filterValues.filter1 === "none") {
    //         setFilterValues({
    //             ...filterValues,
    //             filter1: e.target.value,
    //         })
    //     }
    //     else if (e.target.name === "filter2" && filterValues.filter1 === "none") {
    //         setFilterValues({
    //             ...filterValues,
    //             filter1: e.target.value,
    //         })
    //     }
    //     else
    //         setFilterValues({
    //             ...filterValues,
    //             [e.target.name]: e.target.value
    //         })
    // }
    /**
     * This function is to set the values got from api 
     */
    const setOrderConfigValues = () => {
        try {
            if (orderConfig.length) {
                const result = { ...values };
                const resValidations = {} as { [key: string]: ReturnType<typeof createValidation> }
                orderConfig.forEach((attr) => {
                    resValidations[attr.name] = createValidation(attr)
                    result[attr.name] = attr;
                })
                setValues({ ...result } as orderConfigurationValuesTypes);
                // if (result?.orderTrackingStages?.value?.length) { 
                //     //overriding default values from support with existing order tracking config
                //     const updatedOrderTracking = orderTrackingStagesValues.map(itemA => {
                //         const matchedItemB = result?.orderTrackingStages.value.find((itemB => itemB.id.toLowerCase() === itemA.id.toLowerCase()));
                //         return matchedItemB ? { ...itemA, ...matchedItemB,value:true } : itemA;
                //       }); 
                //       setOrderTrackingStagesValues(updatedOrderTracking);
                // }
                setOrderValidationSchema({ ...resValidations })
            }
        } catch (err) {
            // Sentry.captureException(err);
        }
    }
    
    /**
     * To save the configuration 
     * @param preview it decides that you want to save it as preview configuration or not
     */
    const saveConfiguration = async (preview?: boolean) => {

        // delete objects with value set to false
        // const filteredOrderTrackingStages = orderTrackingStagesValues.filter(item => item.value !== false);

        // Step 2: Remove the value key from all objects
        // const finalOrderTrackingStagesValues:stageType[] = filteredOrderTrackingStages.map(({ value, ...rest }) => rest);

        // const hasInvalidColor = finalOrderTrackingStagesValues.some(item =>  (item.color === '' || item.color?.length !== 7 || item.color[0]!=='#'));
        // const hasEmptyLabel = finalOrderTrackingStagesValues.some(item => item.label==='');
        // if(hasInvalidColor || hasEmptyLabel){
        //     hasEmptyLabel ? openPopup( 'Error','order tracking stages label cannot be empty'):
        //     openPopup( 'Error','Please fill a valid color in order tracking stages');
        //     return ;
        // }
        //otp verification required to run this function
            try {
                // const resultantValues:orderConfigurationValuesTypes = { ...values, orderTrackingStages: {...values.orderTrackingStages,value:finalOrderTrackingStagesValues} };
                const resultantValues:orderConfigurationValuesTypes = { ...values};
                const orderSchema = yup.object({ ...orderValidationsSchema })
                const validationObject:any = {};
                Object.keys(resultantValues).forEach(key=>{
                    validationObject[key] = resultantValues[key].value;
                })
                // await orderSchema.validate(validationObject)
                const convertedVals = convertValuesToConfig(resultantValues, orderConfig);
                newConfigRef.current.order_configuration = convertedVals;
                setShowConfigPopup(true);
            } catch (err) {
                // Sentry.captureException(err);
                console.log("err===", err)
                if (err instanceof Error)
                    openPopup( 'Error',"Validation Error occured : " + err?.message)
            }

    }

    useEffect(() => {
        setOrderConfigValues();
    }, [orderConfig])

    const importConfiguration = async (importedConfig:any)=>{
        const newConfigs = await overWriteConfig(importedConfig, {
            // order_configuration:["orderCalculationType","maxAllowedDigitForOrder","toUseStockFilterInProductsApi","toUseSupplierFilterInApi","pricingApi","offersTabVisibility","offersTabLabel","showSupplierDropdown","showExternalRecommendations","orderInvoiceDisclaimer","orderFeedback","orderIssues","orderCompliment"]
            order_configuration: "importAll"
        })
        newConfigs.forEach((item) => {
            newConfigRef.current[item.domainType] = item.domainValues;
        });
        setShowConfigPopup(true);

    }

    const onConfigComparatorSuccess = async () => {
        await doFinalConfigSubmit("order_configuration", newConfigRef.current.order_configuration, curConfigRef)
        getOrderConfiguration();
    }

    const [importConfigState,setImportConfigState] = useState(false);

    return (
        <div className="order_config_container">
            <ImportConfig importConfigState={importConfigState} setImportConfigState={setImportConfigState} configNames={['order_configuration']} importConfigCallback={importConfiguration} />
            <ConfigurationHeader heading={"Order Configuration"} importConfiguration={()=>{setImportConfigState(true)}} saveConfiguration={() => saveConfiguration(false)} />
            <div className="config_form_container">

                <div className="form_header">
                    <BorderHeading>Order calculation </BorderHeading>
                </div>
                
                {/* <IndentWrapper indent={1}>
                    <QuestionHeading>
                    What should be the default order UOM?
                    </QuestionHeading>
                    <div className="answer_container">
                        <DashboardSelect onChange={handleSelectValueChange} value={values.defaultOrderUOM.value} name="defaultOrderUOM" options={values.defaultOrderUOM.possibleVals ?? []} selectLableId='Select default order unit' />
                    </div>
                </IndentWrapper> */}

                <IndentWrapper indent={1}>
                    <QuestionHeading>
                        How should the order be calculated
                    </QuestionHeading>
                    <div className="answer_container">
                        <DashboardSelect onChange={handleSelectValueChange} value={values.orderCalculationType.value} name="orderCalculationType" options={values.orderCalculationType.possibleVals ?? []} selectLableId='Select order calculation type' />
                    </div>
                </IndentWrapper>

                {/* {values.orderCalculationType && (values.orderCalculationType === "volume" || values.orderCalculationType === "value and volume") && <IndentWrapper indent={2}>
                    <QuestionHeading>
                        Enter the Volume label
                    </QuestionHeading>
                    <div className="answer_container">
                        <Input value={values.volumeDisplayUnit} name="volumeDisplayUnit" onChange={handleValueChange} />
                    </div>
                </IndentWrapper>} */}


                <IndentWrapper indent={1}>
                    <QuestionHeading>
                        Enter the maximum allowed digit for order
                    </QuestionHeading>
                    <div className="answer_container">
                        <Input value={values.maxAllowedDigitForOrder.value} onChange={handleValueChange} name="maxAllowedDigitForOrder" />
                    </div>
                </IndentWrapper>

                <IndentWrapper indent={0}>
                    <QuestionHeading>
                    calculateOnlyOnPac
                    </QuestionHeading>
                    <div className="answer_container">
                        <DashboardCheckbox onChange={handleCheckChange} checked={values.calculateOnlyOnPac.value} name="calculateOnlyOnPac" label="Yes" />
                    </div>
                </IndentWrapper>

                <IndentWrapper indent={0}>
                    <QuestionHeading>
                    stockVisibility
                    </QuestionHeading>
                    <div className="answer_container">
                        <DashboardCheckbox onChange={handleCheckChange} checked={values.stockVisibility.value} name="stockVisibility" label="Yes" />
                    </div>
                </IndentWrapper>

                {/* <div className="form_header">
                    <BorderHeading>CART PAGE </BorderHeading>
                </div>

                <IndentWrapper indent={1}>
                    <QuestionHeading>
                        Do you want to have minimum condition for placing order
                    </QuestionHeading>
                    <div className="answer_container">
                        <DashboardCheckbox onChange={handleCheckChange} checked={values.minOrderValidation.value} name="minOrderValidation" label="Yes" />
                    </div>
                </IndentWrapper>

                {values.minOrderValidation && <>
                    <IndentWrapper indent={2}>
                    <QuestionHeading>
                        Should the minimum order be visible?
                    </QuestionHeading>
                    <div className="answer_container">
                        <DashboardCheckbox onChange={handleCheckChange} checked={values.minOrderVisibility.value} name="minOrderVisibility" label="Yes" />
                    </div>
                </IndentWrapper>


                    <IndentWrapper indent={2}>
                        <QuestionHeading>
                            Min Order condition should be?
                        </QuestionHeading>
                        <div className="answer_container">
                            <DashboardSelect onChange={handleSelectValueChange} value={values.minOrderType.value} name="minOrderType" options={values.minOrderType.possibleVals ?? []} selectLableId='Select min order type' />
                        </div>
                    </IndentWrapper>

                    <IndentWrapper indent={3}>
                        <QuestionHeading>
                            Enter the min order value
                        </QuestionHeading>
                        <div className="answer_container">
                            <Input type='number' onChange={handleValueChange} value={values.minOrder.value} name="minOrder" />
                        </div>
                    </IndentWrapper>

                </>}

                <IndentWrapper indent={1}>
                    <QuestionHeading>
                    Do you wish that the user be able to place orders in sets?
                    </QuestionHeading>
                    <div className="answer_container">
                        <DashboardCheckbox onChange={handleCheckChange} checked={values.buyInSets.value} name="buyInSets" label="Yes" />
                    </div>
                </IndentWrapper>
                <IndentWrapper indent={1}>
                    <QuestionHeading>
                    When the scheme is missed, do you want the user to be able to see a disclaimer that the scheme has been missed?
                    </QuestionHeading>
                    <div className="answer_container">
                    <DashboardCheckbox onChange={handleCheckChange} checked={values.showMissedSchemePopUp.value} name="showMissedSchemePopUp" label="Yes" />
                    </div>
                </IndentWrapper>

                    {values.showMissedSchemePopUp &&
                    

                <IndentWrapper indent={2}>
                        <QuestionHeading>
                        After how much percentage of order
                        </QuestionHeading>
                        <div className="answer_container">
                            <Input value={values.missedPoPUpMargin.value} onChange={handleValueChange} name="missedPoPUpMargin" />
                        </div>
                    </IndentWrapper>
                }


                <IndentWrapper indent={1}>
                    <QuestionHeading>
                        Do you want the information regarding delivery date to be visible?
                    </QuestionHeading>
                    <div className="answer_container">
                        <DashboardCheckbox onChange={handleCheckChange} checked={values.estimatedDeliveryDateVisibility.value} name="estimatedDeliveryDateVisibility" label="Yes" />
                    </div>
                </IndentWrapper>

                
                <IndentWrapper indent={1}>
                    <QuestionHeading>
                        Enter the number of days for delivery in order fulfillment time
                    </QuestionHeading>
                    <div className='answer_container'>
                        <Input type="number" value={values.orderFulfillmentTime.value} onChange={handleValueChange} name="orderFulfillmentTime" />
                    </div>
                </IndentWrapper>

                <IndentWrapper indent={1}>
                    <QuestionHeading>
                        what should be the text in place of order fullfillment time?
                    </QuestionHeading>
                    <div className='answer_container'>
                        <Input value={values.orderFulfillmentTimeMessage.value} onChange={handleValueChange} name="orderFulfillmentTimeMessage" />
                    </div>
                </IndentWrapper>

                <IndentWrapper indent={1}>
                    <QuestionHeading>
                        What should be the label for Fulfilled by?
                    </QuestionHeading>
                    <div className="answer_container">
                        <Input value={values.fullFilledByLabel.value} onChange={handleValueChange} name="fullFilledByLabel" />
                    </div>
                </IndentWrapper>

               
                <IndentWrapper indent={1}>
                    <QuestionHeading>
                    In the basket titled: “items you may have missed”, which basket should be displayed?
                    </QuestionHeading>
                    <div className="answer_container">
                        <DashboardSelect onChange={handleSelectValueChange} value={values.missedItemBasket.value} name="missedItemBasket" options={basketTitles} selectLableId='missed basket' />
                    </div>
                </IndentWrapper> */}


                {/* temporarily commented for now */}

                {/* <div className="form_header">
                    <BorderHeading>Order Type</BorderHeading>
                </div>
                <IndentWrapper indent={1}>
                    <QuestionHeading>
                        What types of orders do you wish to activate?
                    </QuestionHeading>
                    <div className="generic_form_container odd_container">
                        <DashboardCheckbox onChange={handleCheckChange} name="teleOrder" checked={values.teleOrder} label="Remote Order" />
                        <DashboardCheckbox onChange={handleCheckChange} name="remoteOrder" checked={values.remoteOrder} label="Tele Order" />
                        <DashboardCheckbox onChange={handleCheckChange} name="visitOrder" checked={values.visitOrder} label="Visit Order" />
                    </div>
                </IndentWrapper> */}

                {/* <div className="form_header">
                    <BorderHeading>CHECKOUT PAGE</BorderHeading>
                </div>

               

                <IndentWrapper indent={1}>
                    <QuestionHeading>
                        Do you want to show distributor visibility and details?
                    </QuestionHeading>
                    <div className="answer_container">
                        <DashboardCheckbox onChange={handleCheckChange} checked={values.distributorVisibility.value} name="distributorVisibility" label="Yes" />
                    </div>
                </IndentWrapper>
                <IndentWrapper indent={1}>
                    <QuestionHeading>
                    Can the user see the distributor ID on checkout page?
                    </QuestionHeading>
                    <div className="answer_container">
                        <DashboardCheckbox onChange={handleCheckChange} checked={values.orderDSIdVisibility.value} name="orderDSIdVisibility" label="Yes" />
                    </div>
                </IndentWrapper>

                <IndentWrapper indent={1}>
                    <QuestionHeading>
                    Do you want the user to see the retailer margin?
                    </QuestionHeading>
                    <div className="answer_container">
                        <DashboardCheckbox onChange={handleCheckChange} checked={values.retailerMarginVisibility.value} name="retailerMarginVisibility" label="Yes" />
                    </div>
                </IndentWrapper>

                <IndentWrapper indent={1}>
                    <QuestionHeading>
                    Do you want that the free label to be displayed alongside the free product? 
                    </QuestionHeading>
                    <div className="answer_container">
                        <DashboardCheckbox onChange={handleCheckChange} checked={values.showFreeProductLabel.value} name="showFreeProductLabel" label="Yes" />
                    </div>
                </IndentWrapper>
                

                <IndentWrapper indent={1}>
                    <QuestionHeading>
                        Do you wish to have any remarks for Order?
                    </QuestionHeading>
                    <div className="answer_container">
                        <DashboardCheckbox onChange={handleCheckChange} checked={values.orderRemarksVisibility.value} name="orderRemarksVisibility" label="Yes" />
                    </div>
                </IndentWrapper>

                <IndentWrapper indent={1}>
                    <QuestionHeading>
                    Do you want display the total amount calculation?
                    </QuestionHeading>
                    <div className="answer_container">
                        <DashboardCheckbox onChange={handleCheckChange} checked={values.amountCalculation.value} name="amountCalculation" label="Yes" />
                    </div>
                </IndentWrapper>

                <IndentWrapper indent={1}>
                    <QuestionHeading>
                    is the minimum order condition visible to the user?
                    </QuestionHeading>
                    <div className="answer_container">
                        <DashboardCheckbox onChange={handleCheckChange} checked={values.minOrderVisibility.value} name="minOrderVisibility" label="Yes" />
                    </div>
                </IndentWrapper>

                <IndentWrapper indent={1}>
                    <QuestionHeading>
                        How should the scheme be calculated?
                    </QuestionHeading>
                    <div className="answer_container">
                        <DashboardSelect onChange={handleSelectValueChange} value={values.schemeCalculation.value} name="schemeCalculation" options={values.schemeCalculation.possibleVals ?? []} selectLableId='Select where to calculate scheme' />
                    </div>
                </IndentWrapper>


                <IndentWrapper indent={1}>
                    <QuestionHeading>
                        Do you wish to have disclaimers?
                    </QuestionHeading>
                    <div className="generic_form_container even_container">
                        <Input value={values.orderSummaryDisclaimer?.value?.[0]} onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleDisclaimerChange(e, 0)} name="orderSummaryDisclaimer" />
                        <Input value={values.orderSummaryDisclaimer?.value?.[1]} onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleDisclaimerChange(e, 1)} name="orderSummaryDisclaimer" />
                    </div>
                </IndentWrapper>

                <IndentWrapper indent={0}>
                    <QuestionHeading>
                    What should be the label for PTR on the checkout page?
                    </QuestionHeading>
                    <div className="answer_container">
                        <Input value={values.orderCheckoutPtrLabel.value} onChange={handleValueChange} name="orderCheckoutPtrLabel" />
                    </div>
                </IndentWrapper>
                <IndentWrapper indent={0}>
                    <QuestionHeading>
                    What should be the label of the unit in order summary?
                    </QuestionHeading>
                    <div className="answer_container">
                        <Input value={values.orderCheckoutUnitLabel.value} onChange={handleValueChange} name="orderCheckoutUnitLabel" />
                    </div>
                </IndentWrapper>
                <IndentWrapper indent={0}>
                    <QuestionHeading>
                    What should be the label of the final amount?
                    </QuestionHeading>
                    <div className="answer_container">
                        <Input value={values.orderCheckoutFinalAmountLabel.value} onChange={handleValueChange} name="orderCheckoutFinalAmountLabel" />
                    </div>
                </IndentWrapper>
                <IndentWrapper indent={0}>
                    <QuestionHeading>
                    What should be the label of the total amount?
                    </QuestionHeading>
                    <div className="answer_container">
                        <Input value={values.orderCheckoutTotalAmountLabel.value} onChange={handleValueChange} name="orderCheckoutTotalAmountLabel" />
                    </div>
                </IndentWrapper> */}


                {/* commented for now */}
                
                {/* <IndentWrapper indent={1}>
                    <QuestionHeading>
                        Check the features you want to have
                    </QuestionHeading>
                    <div className="generic_form_container odd_container">
                        <DashboardCheckbox onChange={handleCheckChange} checked={values.saveOrder} name="saveOrder" label="Save Order" />
                        <DashboardCheckbox onChange={handleCheckChange} checked={values.orderPo} name="orderPo" label="Order Po" />
                        <DashboardCheckbox onChange={handleCheckChange} checked={values.onlineCart} name="onlineCart" label="Online Cart" />
                    </div>
                </IndentWrapper> */}

                {/* <div className="form_header">
                    <BorderHeading>ORDER TRACKING CONFIG</BorderHeading>
                </div>

                <IndentWrapper indent={0}>
                    <QuestionHeading>
                        What all stages do you want to display? **
                    </QuestionHeading>
                    {
                        orderTrackingStages?.map((stage, index) => {
                            return <OrderTrackingStageInput index={index} stage={stage} OrderTrackingStagesValues={orderTrackingStagesValues} setOrderTrackingStagesValues={setOrderTrackingStagesValues} />
                        })
                    }
                </IndentWrapper>

                <IndentWrapper indent={0}>
                    <QuestionHeading>
                        What is the range for date to track order(in days)?
                    </QuestionHeading>
                    <div className="answer_container">
                        <Input value={values.orderTrackingDefaultRange.value} onChange={handleValueChange} name="orderTrackingDefaultRange" />
                    </div>
                </IndentWrapper>

                <IndentWrapper indent={0}>
                    <QuestionHeading>
                        Do you wish to see the normalized quantity of the purchased order?
                    </QuestionHeading>
                    <div className="answer_container">
                        <DashboardCheckbox onChange={handleCheckChange} checked={values.normalisedQtyVisibility.value} name="normalisedQtyVisibility" label="Yes" />
                    </div>
                </IndentWrapper>
                <IndentWrapper indent={0}>
                    <QuestionHeading>
                    Do you wish to see the invoice for the order tracking screen?
                    </QuestionHeading>
                    <div className="answer_container">
                        <DashboardCheckbox onChange={handleCheckChange} checked={values.orderTrackingInvoiceVisibility.value} name="orderTrackingInvoiceVisibility" label="Yes" />
                    </div>
                </IndentWrapper>

                

                <IndentWrapper indent={0}>
                    <QuestionHeading>
                    Do you wish to see the billing amount information?
                    </QuestionHeading>
                    <div className="answer_container">
                        <DashboardCheckbox onChange={handleCheckChange} checked={values.billingInformationVisibility.value} name="billingInformationVisibility" label="Yes" />
                    </div>
                </IndentWrapper>

                <IndentWrapper indent={0}>
                    <QuestionHeading>
                    Can the user see the discount coupon? 
                    </QuestionHeading>
                    <div className="answer_container">
                        <DashboardCheckbox onChange={handleCheckChange} checked={values.discountCouponVisibility.value} name="discountCouponVisibility" label="Yes" />
                    </div>
                </IndentWrapper>

                <IndentWrapper indent={0}>
                    <QuestionHeading>
                        Do you want  to enable order cancellation?
                    </QuestionHeading>
                    <div className="answer_container">
                        <DashboardCheckbox onChange={handleCheckChange} checked={values.orderCancellation.value} name="orderCancellation" label="Yes" />
                    </div>
                </IndentWrapper>

                {values.orderCancellation.value &&
                <> */}


                    {/* bellow 2 not using */}
                    {/* <IndentWrapper indent={2}>
                    <QuestionHeading>
                        orderCancellationTimer
                    </QuestionHeading>
                    <div className="answer_container">
                        <Input value={values.orderCancellationTimer} onChange={handleValueChange} name="orderCancellationTimer" />
                    </div>
                    </IndentWrapper> */}

                    {/* <IndentWrapper indent={2}>
                    <QuestionHeading>
                    Do you wish that the user could cancel the order in the order tracking screen?
                    </QuestionHeading>
                    <div className="answer_container">
                        <DashboardCheckbox onChange={handleCheckChange} checked={values.cancelOrderInOrdertracking} name="cancelOrderInOrdertracking" label="Yes" />
                    </div>
                    </IndentWrapper> */}
                    
                    {/* <IndentWrapper indent={2}>
                    <QuestionHeading>
                    What text should the user see as a disclaimer before order cancellation?
                    </QuestionHeading>
                    <div className="answer_container">
                        <Input value={values.orderCancellationDisclaimer.value} onChange={handleValueChange} name="orderCancellationDisclaimer" />
                    </div>
                </IndentWrapper>

                <IndentWrapper indent={2}>
                    <QuestionHeading>
                    What text should the user see after order cancellation?
                    </QuestionHeading>
                    <div className="answer_container">
                        <Input value={values.orderCancellationSummaryDisclaimer.value} onChange={handleValueChange} name="orderCancellationSummaryDisclaimer" />
                    </div>
                </IndentWrapper>

                <IndentWrapper indent={2}>
                    <QuestionHeading>
                    orderCancellationReasons
                    </QuestionHeading>
                    <div className="generic_form_container even_container">
                        <Input value={values.orderCancellationReasons?.value?.[0]} onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleDisclaimerChange(e, 0)} name="orderCancellationReasons" />
                        <Input value={values.orderCancellationReasons?.value?.[1]} onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleDisclaimerChange(e, 1)} name="orderCancellationReasons" />
                    </div>
                </IndentWrapper>

                <IndentWrapper indent={2}>
                    <QuestionHeading>
                    What should be the order cancellation time period (in minutes)?
                    </QuestionHeading>
                    <div className="answer_container">
                        <Input value={values.orderCancellationPeriod.value} onChange={handleValueChange} name="orderCancellationPeriod" />
                    </div>
                </IndentWrapper>

                    </>


                }

                <IndentWrapper indent={0}>
                    <QuestionHeading>
                        Do you want to enable reorder?
                    </QuestionHeading>
                    <div className="answer_container">
                        <DashboardCheckbox onChange={handleCheckChange} checked={values.reOrder.value} name="reOrder" label="Yes" />
                    </div>
                </IndentWrapper> */}

                    {/* temporarily commented */}

                {/* <div className="form_header">
                    <BorderHeading>ORDER NOTIFICATION CONFIGURATION</BorderHeading>
                </div>

                <IndentWrapper indent={0}>
                    <QuestionHeading>
                        Do you wish to popup notification on first order?
                    </QuestionHeading>
                    <div className="answer_container">
                        <DashboardCheckbox onChange={handleCheckChange} checked={values.showFirstOrderBanner} name="showFirstOrderBanner" label="Yes" />
                    </div>
                </IndentWrapper>

                <IndentWrapper indent={0}>
                    <QuestionHeading>
                        Do you wish to popup notification on all orders?
                    </QuestionHeading>
                    <div className="answer_container">
                        <DashboardCheckbox onChange={handleCheckChange} checked={values.orderNotification} name="orderNotification" label="Yes" />
                    </div>
                </IndentWrapper> */}

                {/* <div className="form_header">
                    <BorderHeading>EDIT ORDER CONFIGURATION</BorderHeading>
                </div>

                <IndentWrapper indent={0}>
                    <QuestionHeading>
                        do you want user to be able to edit order?
                    </QuestionHeading>
                    <div className="answer_container">
                        <DashboardCheckbox onChange={handleCheckChange} checked={values.editOrder.value} name="editOrder" label="Yes" />
                    </div>
                </IndentWrapper> */}

                {/* <IndentWrapper indent={0}>
                    <QuestionHeading>
                        do you want user to be able to edit and add  to order?
                    </QuestionHeading>
                    <div className="answer_container">
                        <DashboardCheckbox onChange={handleCheckChange} checked={values.editAndAddOrder} name="editAndAddOrder" label="Yes" />
                    </div>
                </IndentWrapper> */}

                {/* <div className="form_header">
                    <BorderHeading> ORDER NUMBER CONFIGURATION</BorderHeading>
                </div> */}

                {/* <IndentWrapper indent={0}>
                    <QuestionHeading>
                        What should be the series of order number?
                    </QuestionHeading>
                    <div className="answer_container">
                        <Input value={values.startValue} onChange={handleValueChange} name="startValue" />
                    </div>
                </IndentWrapper> */}

                {/* <IndentWrapper indent={0}>
                    <QuestionHeading>
                        What should be the length of order number?
                    </QuestionHeading>
                    <div className="answer_container">
                        <Input value={values.sequenceLength} onChange={handleValueChange} name="sequenceLength" />
                    </div>
                </IndentWrapper> */}

                {/* <IndentWrapper indent={0}>
                    <QuestionHeading>
                        what should be the prefix of order number?
                    </QuestionHeading>
                    <div className="answer_container">
                        <Input value={values.prefix} onChange={handleValueChange} name="prefix" />
                    </div>
                </IndentWrapper> */}

                {/* <IndentWrapper indent={0}>
                    <QuestionHeading>
                        what should be the suffix of order number?
                    </QuestionHeading>
                    <div className="answer_container">
                        <Input value={values.suffix} onChange={handleValueChange} name="suffix" />
                    </div>
                </IndentWrapper> */}

                {/* temporarily commented */}

                {/* <div className="form_header">
                    <BorderHeading>STOCK AVAILABILITY CONFIGURATION</BorderHeading>
                </div>

                <IndentWrapper indent={0}>
                    <QuestionHeading>
                        Should there be stock visibility?
                    </QuestionHeading>
                    <div className="answer_container">
                        <DashboardCheckbox onChange={handleCheckChange} checked={values.stockVisibility} name="stockVisibility" label="Yes" />
                    </div>
                </IndentWrapper>

                <IndentWrapper indent={0}>
                    <QuestionHeading>
                        Should there be stock validation?
                    </QuestionHeading>
                    <div className="answer_container">
                        <DashboardCheckbox onChange={handleCheckChange} checked={values.stockValidation} name="stockValidation" label="Yes" />
                    </div>
                </IndentWrapper> */}

                <div className="form_header">
                    <BorderHeading>OTHER CONFIGURATIONS </BorderHeading>
                </div>

                <IndentWrapper indent={1}>
                    <QuestionHeading>
                    orderCheckoutDefaultUnitLabel
                    </QuestionHeading>
                    <div className="answer_container">
                        <Input value={values.orderCheckoutDefaultUnitLabel.value} onChange={handleValueChange} name="orderCheckoutDefaultUnitLabel" />
                    </div>
                </IndentWrapper>

                <IndentWrapper indent={0}>
                    <QuestionHeading>
                    avoidRecommendationMerging
                    </QuestionHeading>
                    <div className="answer_container">
                        <DashboardCheckbox onChange={handleCheckChange} checked={values.avoidRecommendationMerging.value} name="avoidRecommendationMerging" label="Yes" />
                    </div>
                </IndentWrapper>
                <IndentWrapper indent={0}>
                    <QuestionHeading>
                    toUseSupplierFilterInProductsApi
                    </QuestionHeading>
                    <div className="answer_container">
                        <DashboardCheckbox onChange={handleCheckChange} checked={values.toUseSupplierFilterInProductsApi.value} name="toUseSupplierFilterInProductsApi" label="Yes" />
                    </div>
                </IndentWrapper>


                <IndentWrapper indent={0}>
                    <QuestionHeading>
                    Do you want users to see all products on catalogue page, that is, all products should be fetched from the API at once?
                    </QuestionHeading>
                    <div className="answer_container">
                        <DashboardCheckbox onChange={handleCheckChange} checked={values.toUseStockFilterInProductsApi.value} name="toUseStockFilterInProductsApi" label="Yes" />
                    </div>
                </IndentWrapper>

                <IndentWrapper indent={0}>
                    <QuestionHeading>
                    Do you want that the product metadata should be supplier-specific?
                    </QuestionHeading>
                    <div className="answer_container">
                        <DashboardCheckbox onChange={handleCheckChange} checked={values.toUseSupplierFilterInApi.value} name="toUseSupplierFilterInApi" label="Yes" />
                    </div>
                </IndentWrapper>

                {/* <IndentWrapper indent={0}>
                    <QuestionHeading>
                    skipOffersInProductApi
                    </QuestionHeading>
                    <div className="answer_container">
                        <DashboardCheckbox onChange={handleCheckChange} checked={values.skipOffersInProductApi} name="skipOffersInProductApi" label="Yes" />
                    </div>
                </IndentWrapper> */}

                <IndentWrapper indent={0}>
                    <QuestionHeading>
                    Do you want to use PricingAPI?
                    </QuestionHeading>
                    <div className="answer_container">
                        <DashboardCheckbox onChange={handleCheckChange} checked={values.pricingApi.value} name="pricingApi" label="Yes" />
                    </div>
                </IndentWrapper>

                <IndentWrapper indent={0}>
                    <QuestionHeading>
                    Should there be an offers tab in the orders tab?
                    </QuestionHeading>
                    <div className="answer_container">
                        <DashboardCheckbox onChange={handleCheckChange} checked={values.offersTabVisibility.value} name="offersTabVisibility" label="Yes" />
                    </div>
                </IndentWrapper>

                {values.offersTabVisibility.value && <IndentWrapper indent={2}>
                    <QuestionHeading>
                    What should be the label for the “offers tab”?
                    </QuestionHeading>
                    <div className="answer_container">
                        <Input value={values.offersTabLabel.value} onChange={handleValueChange} name="offersTabLabel" />
                    </div>
                </IndentWrapper>}

                <IndentWrapper indent={0}>
                    <QuestionHeading>
                    Can the user see the list of supplier IDs?
                    </QuestionHeading>
                    <div className="answer_container">
                        <DashboardCheckbox onChange={handleCheckChange} checked={values.showSupplierDropdown.value} name="showSupplierDropdown" label="Yes" />
                    </div>
                </IndentWrapper>

                <IndentWrapper indent={0}>
                    <QuestionHeading>
                    Do you have external recommendations?
                    </QuestionHeading>
                    <div className="answer_container">
                        <DashboardCheckbox onChange={handleCheckChange} checked={values.showExternalRecommendations.value} name="showExternalRecommendations" label="Yes" />
                    </div>
                </IndentWrapper>

               

                <div className="form_header">
                    <BorderHeading>ORDER FEEDBACK</BorderHeading>
                </div>

                {/* <IndentWrapper indent={1}>
                    <QuestionHeading>
                    Enter disclaimers for user on feedback screen
                    </QuestionHeading>
                    <div className="generic_form_container even_container">
                        <Input value={values.orderInvoiceDisclaimer?.value?.[0]} onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleDisclaimerChange(e, 0)} name="orderInvoiceDisclaimer" />
                        <Input value={values.orderInvoiceDisclaimer?.value?.[1]} onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleDisclaimerChange(e, 1)} name="orderInvoiceDisclaimer" />
                    </div>
                </IndentWrapper> */}

                <IndentWrapper indent={1}>
                    <InputList values={values} question="Enter disclaimers for user on feedback screen" setValues={setValues} configName="orderInvoiceDisclaimer" />
                </IndentWrapper>

                <IndentWrapper indent={0}>
                    <QuestionHeading>
                        Do you want enable order feedback?
                    </QuestionHeading>
                    <div className="answer_container">
                        <DashboardCheckbox onChange={handleCheckChange} checked={values.orderFeedback.value} name="orderFeedback" label="Yes" />
                    </div>
                </IndentWrapper>

                {values.orderFeedback.value &&
                    <IndentWrapper indent={2}>
                        <QuestionHeading>
                            Provide issues for feedback section
                        </QuestionHeading>
                        <div className="generic_form_container even_container">
                            <Input onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleFeedbackChange(e, 0, "issues")} value={values.orderIssues?.value?.[0]} name="orderIssues" />
                            <Input onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleFeedbackChange(e, 1, "issues")} value={values.orderIssues?.value?.[1]} name="orderIssues" />
                        </div>
                        <div className="generic_form_container even_container">
                            <Input onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleFeedbackChange(e, 2, "issues")} value={values.orderIssues?.value?.[2]} name="orderIssues" />
                            <Input onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleFeedbackChange(e, 3, "issues")} value={values.orderIssues?.value?.[3]} name="orderIssues" />
                        </div>
                    </IndentWrapper>
                }

                {values.orderFeedback.value &&
                    <IndentWrapper indent={2}>
                        <QuestionHeading>
                            Provide compliments for feedback section
                        </QuestionHeading>
                        <div className="generic_form_container even_container">
                            <Input onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleFeedbackChange(e, 0)} value={values.orderCompliment?.value?.[0]} name="orderCompliment" />
                            <Input onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleFeedbackChange(e, 1)} value={values.orderCompliment?.value?.[1]} name="orderCompliment" />
                        </div>
                        <div className="generic_form_container even_container">
                            <Input onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleFeedbackChange(e, 2)} value={values.orderCompliment?.value?.[2]} name="orderCompliment" />
                            <Input onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleFeedbackChange(e, 3)} value={values.orderCompliment?.value?.[3]} name="orderCompliment" />
                        </div>
                    </IndentWrapper>
                }


                {/* <IndentWrapper indent={0}>
                    <QuestionHeading>
                        what should be the first filter for catalogue filtering?
                    </QuestionHeading>
                    <div className="answer_container">
                        <DashboardSelect onChange={handleFilterValueChange} value={filterValues.filter1} name="filter1" options={filterOptions.filter(opt => {
                            return (opt.value !== filterValues.filter2 && opt.value !== filterValues.filter3) || opt.value === "none"
                        })} selectLableId='Filter 1' />
                    </div>

                </IndentWrapper>

                <IndentWrapper indent={0}>
                    <QuestionHeading>
                        what should be the second filter for catalogue filtering?
                    </QuestionHeading>
                    <div className="answer_container">
                        <DashboardSelect onChange={handleFilterValueChange} disabled={filterValues.filter1 === "none"} value={filterValues.filter2} name="filter2" options={filterOptions.filter(opt => {
                            return (opt.value !== filterValues.filter1 && opt.value !== filterValues.filter3) || opt.value === "none"
                        })} selectLableId='Filter 2' />
                    </div>
                </IndentWrapper>

                <IndentWrapper indent={0}>
                    <QuestionHeading>
                        what should be the third filter for catalogue filtering?
                    </QuestionHeading>
                    <div className="answer_container">
                        <DashboardSelect onChange={handleFilterValueChange} disabled={filterValues.filter1 === "none" || filterValues.filter2 === "none"} value={filterValues.filter3} name="filter3" options={filterOptions.filter(opt => {
                            return (opt.value !== filterValues.filter1 && opt.value !== filterValues.filter2) || opt.value === "none"
                        })} selectLableId='Filter 3' />
                    </div>

                </IndentWrapper> */}

            </div>
            <ConfigComparePopup message="Are you sure want to update the config" showConfigPopup={showConfigPopup} setShowConfigPopup={setShowConfigPopup} curConfig={curConfigRef.current} newConfig={newConfigRef.current} onSuccess={onConfigComparatorSuccess} />
        </div>
    )
}

export default OrderConfiguration

